import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function TopBar() {
    const [time, setTime] = useState(new Date());

    // 🔴 Live time updater
    useEffect(() => {
        const timer = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const mobileTime = time.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    const desktopTime = time.toLocaleString("en-IN", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    });

    return (
        <div className="w-full max-w-full overflow-x-hidden sticky top-0 z-50">

            {/* ================= MOBILE ================= */}
            <div className="lg:hidden bg-gradient-to-r from-[#081f3f] to-[#0b3b6e] text-white">

                {/* TOP ROW */}
                <div className="flex items-center justify-between px-4 py-2 text-xs">
                    <div className="flex items-center gap-2 font-semibold">
                        <span className="flex items-center gap-1 bg-red-600 px-2 py-[2px] rounded-full animate-pulse">
                            <span className="w-2 h-2 bg-white rounded-full"></span>
                            LIVE
                        </span>
                        <span>{mobileTime}</span>
                    </div>

                    <Link
                        to="/login"
                        title="Login"
                        className="text-lg opacity-80 hover:opacity-100"
                    >
                        👤
                    </Link>
                </div>

                {/* BOTTOM ROW */}
                <div className="flex justify-center gap-6 py-2 border-t border-white/10 text-[11px]">
                    <Link to="/about" className="opacity-80 hover:opacity-100">About</Link>
                    <Link to="/contact" className="opacity-80 hover:opacity-100">Contact</Link>
                    <Link to="/privacy-policy" className="opacity-70 hover:opacity-100">Privacy</Link>
                    <Link to="/terms-conditions" className="opacity-70 hover:opacity-100">Terms</Link>
                </div>
            </div>

            {/* ================= DESKTOP ================= */}
            <div className="hidden lg:flex bg-gradient-to-r from-[#081f3f] via-[#0b2f57] to-[#081f3f] text-white px-6 py-2 justify-between items-center text-sm">

                {/* LEFT: LIVE + LINKS */}
                <div className="flex items-center gap-5">
                    <span className="flex items-center gap-1 bg-red-600 px-3 py-1 rounded-full text-xs font-bold animate-pulse">
                        LIVE
                    </span>

                    <Link to="/about" className="hover:text-yellow-300">About</Link>
                    <Link to="/contact" className="hover:text-yellow-300">Contact</Link>
                    <Link to="/privacy-policy" className="opacity-80 hover:text-yellow-300">Privacy</Link>
                    <Link to="/terms-conditions" className="opacity-80 hover:text-yellow-300">Terms</Link>
                </div>

                {/* RIGHT: TIME + USER */}
                <div className="flex items-center gap-5">
                    <span className="font-semibold whitespace-nowrap text-gray-200">
                        🕒 {desktopTime}
                    </span>

                    <Link
                        to="/login"
                        className="flex items-center gap-1 font-semibold hover:text-yellow-300"
                    >
                        👤 Login
                    </Link>
                </div>
            </div>
        </div>
    );
}
